import React from 'react';

import Paper from 'material-ui/Paper';

import List, {ListItem, ListItemText, ListItemSecondaryAction} from 'material-ui/List';
import Switch from 'material-ui/Switch';
import Divider from 'material-ui/Divider';
import Select from 'material-ui/Select';
import Grid from 'material-ui/Grid';
import {MenuItem} from 'material-ui/Menu';
import TextField from '../../../../components/forms/ValidatedTextField';

import {Translate} from 'material-ui-icons';

import tsl from './../../../tsl';
import axios from 'axios';

import LogoUpload from '../LogoUpload';
import IconButton from 'material-ui/IconButton';
import PreviewIcon from 'material-ui-icons/Visibility';
import DownloadIcon from 'material-ui-icons/CloudDownload';
import config from './../../../../config';
import {isURL} from '../../../../components/forms/validations';
import withValidatedInputs from '../../../../components/forms/withValidatedInputs';
import {addAlert} from '../../../../actions/Alerts';
import {connect} from 'react-redux';
import {getSettings, loadSettings} from 'utils/client';
import {FormControl, InputLabel} from "material-ui";
import moment from 'moment-timezone';

class Company extends React.Component {

    years = [];
    timezones = [];

    state = {
        settings: {
            booking_emails: false,
            payment_type_ids: [],
            exclusive_payment_type_ids: [],
            currency_code: '',
            voucher_valid_years: 0,
            email_type_overrides: [],
            tos_is_url: false,
            safety_is_url: false,
            weight_unit: 'kg',
            email: '',
            phone: '',
            ampm: false,
            timezone: '',
            translations: {},
            stripe_public_key: '',
            stripe_secret_key: '',
        },
        settingsLoaded: false,
        language: null,
        languages: null,
        payment_types: null,
        currencies: null,
        email_types: null,
        activeLanguage: null
    };

    constructor(props) {
        super(props);

        for (let i = 1; i <= 30; i++) {
            this.years.push(i);
        }
    }

    componentDidMount() {
        const settings = {
            ...this.state.settings
        };

        const storedSettings = getSettings();

        settings.booking_emails = storedSettings.booking_emails > 0;
        settings.payment_type_ids = storedSettings.payment_types.map(pt => {
            return pt.id
        });
        settings.exclusive_payment_type_ids = storedSettings.exclusive_payment_types.map(pt => {
            return pt.id
        });
        settings.currency_code = storedSettings.currency_code;
        settings.voucher_valid_years = storedSettings.voucher_valid_years;
        settings.logo = storedSettings.logo;
        settings.voucher_template = storedSettings.voucher_template;
        settings.email_type_overrides = storedSettings.email_type_overrides;
        settings.tos_url = storedSettings.tos_url;
        settings.tos_is_url = !!storedSettings.tos_url;
        settings.safety_url = storedSettings.safety_url;
        settings.safety_is_url = !!storedSettings.safety_url;
        settings.tos_file = storedSettings.tos_file;
        settings.safety_file = storedSettings.safety_file;
        settings.enable_flight_requests = storedSettings.enable_flight_requests;
        settings.weight_unit = storedSettings.weight_unit;
        settings.ampm = storedSettings.ampm;
        settings.timezone = storedSettings.timezone;
        settings.voucher_bound_to_offer = storedSettings.voucher_bound_to_offer;
        settings.email = storedSettings.email;
        settings.phone = storedSettings.phone;
        settings.survey_url = storedSettings.survey_url;
        settings.website_url = storedSettings.website_url;
        settings.stripe_public_key = storedSettings.stripe_public_key;
        settings.stripe_secret_key = storedSettings.stripe_secret_key;

        // reindex translations by locale
        settings.translations = {};
        storedSettings.translations.map(t => {
            settings.translations[t.locale] = t;
        });

        this.setState({
            settings,
            settingsLoaded: true,
            timezones: moment.tz.names()
        });


        axios.get('/language')
            .then(res => {
                this.setState({languages: res.data, activeLanguage: res.data[0].iso_code})
            });

        axios.get('/api/payment/types')
            .then(res => {
                this.setState({payment_types: res.data})
            });

        axios.get('/api/currency')
            .then(res => {
                this.setState({currencies: res.data})
            });

        axios.get('/api/operator/settings/email/types')
            .then(res => {
                this.setState({email_types: res.data})
            });
    }

    componentWillUnmount() {
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }
    }

    saveSettings = (settings, timeout = 500) => {
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }

        if (!this.props.isFormValid) {
            // don't save invalid form
            return;
        }

        this.saveTimeout = setTimeout(
            () => axios.post('/api/operator/settings', {
                ...settings,
                tos_url: settings.tos_is_url ? settings.tos_url : null,
                safety_url: settings.safety_is_url ? settings.safety_url : null,
            }).then(loadSettings), // save settings and refresh copy in redux store
            timeout
        );
    };

    handleLanguageChange = (e) => {
        let state = this.state;
        state.language = e.target.value;
        this.setState({state: state});
    };

    handleSwitchChange = (attr) => (e, checked) => {
        let settings = this.state.settings;
        settings[attr] = checked;
        this.setState({settings: settings});
        this.saveSettings(settings);
    }

    handleEmailSwitchChange = (email_type_id) => (e, checked) => {
        this.setState(state => {

            const email_type_overrides = [...state.settings.email_type_overrides];

            const override = email_type_overrides.find(o => o.email_type_id == email_type_id);
            if (override) {
                override.enabled = checked;
            } else {
                email_type_overrides.push({
                    email_type_id: email_type_id,
                    enabled: checked
                });
            }

            return {
                settings: {
                    ...state.settings,
                    email_type_overrides
                }
            };
        }, () => {
            this.saveSettings(this.state.settings);
        });
    };

    handleSelectChange = (attr) => (e) => {
        let settings = this.state.settings;
        settings[attr] = e.target.value;
        this.setState({settings: settings});
        this.saveSettings(settings);
    }


    handleLogoUpload = (logo) => {
        // set this file

        let settings = this.state.settings;
        settings['logo'] = logo;

        this.setState({
            settings
        });

        this.saveSettings(settings);
    };

    handleVoucherTemplateUpload = (template) => {
        // set this file

        let settings = this.state.settings;
        settings['voucher_template'] = template;

        this.setState({
            settings
        });

        this.saveSettings(settings);
    };

    handleInputChange = (e) => {
        const settings = {
            ...this.state.settings,
            [e.target.name]: e.target.value
        };

        this.setState({
            settings
        });

        this.saveSettings(settings, 1500);
    };

    handleTranslationInputChange = (e) => {
        const target = e.target;
        const lang = this.state.activeLanguage;

        this.setState(state => ({
            settings: {
                ...state.settings,
                translations: {
                    ...state.settings.translations,
                    [lang]: {
                        ...state.settings.translations[lang],
                        locale: lang,
                        [target.name]: target.value
                    }
                }
            }
        }), () => {
            this.saveSettings(this.state.settings, 1500);
        });
    };

    handleUpload = (e) => {
        if (e.target.files.length == 0) return;

        const file = e.target.files[0];

        if (file.type.indexOf('pdf') === -1) {
            this.props.addAlert(tsl('settings.logo.incorrect_file_type'), 'error');
            return;
        }

        var data = new FormData();
        data.append('uploadedFile', file);

        const inputName = e.target.name;

        axios.post('/files/upload', data)
            .then((res) => {
                // console.log('success upload', res.data);

                const settings = {
                    ...this.state.settings,
                    [inputName]: res.data
                };

                this.setState({
                    settings
                });

                this.saveSettings(settings);
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    getTestVoucherLink(f) {
        const token = axios.defaults.headers.common['Authorization'].replace('Bearer ', '');

        return `${config.API_ROOT}voucher/preview?f=${f}&_token=${token}`;
    }

    handleChangeLanguage = event => {
        this.setState({activeLanguage: event.target.value});
    };

    render() {
        const {
            settings,
            languages,
            payment_types,
            currencies,
            email_types,
            settingsLoaded
        } = this.state;

        if (!settingsLoaded || languages === null || payment_types === null || currencies === null || email_types === null) {
            return null;
        }

        console.log(settings);
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material">
                        <List>
                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.homepage_url')}
                                            // secondary={tsl('settings.homepage_url.info')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>

                                        <TextField
                                            validateOnMount
                                            fullWidth
                                            name="website_url"
                                            onChange={this.handleInputChange}
                                            value={settings.website_url || ''}
                                            placeholder="http://"
                                            validations={[
                                                isURL
                                            ]}
                                            formActions={this.props.formActions}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>

                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.phone')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>

                                        <TextField
                                            validateOnMount
                                            fullWidth
                                            name="phone"
                                            onChange={this.handleInputChange}
                                            value={settings.phone || ''}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>

                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.email')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>

                                        <TextField
                                            validateOnMount
                                            fullWidth
                                            name="email"
                                            onChange={this.handleInputChange}
                                            value={settings.email || ''}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>

                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.contact_info')}
                                                      secondary={
                                                          <FormControl fullWidth>
                                                              <InputLabel
                                                                  htmlFor="language">{tsl('locations.editform.language_to_edit')}</InputLabel>
                                                              <Select
                                                                  name="language"
                                                                  value={this.state.activeLanguage}
                                                                  onChange={this.handleChangeLanguage}
                                                              >
                                                                  {languages.map((lang) => {
                                                                      return (<MenuItem key={lang.iso_code}
                                                                                        value={lang.iso_code}>{lang.name}</MenuItem>);
                                                                  })}
                                                              </Select>
                                                          </FormControl>
                                                      }
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>

                                        <TextField
                                            rows={3}
                                            multiline
                                            fullWidth
                                            name="contact_info"
                                            onChange={this.handleTranslationInputChange}
                                            value={settings.translations[this.state.activeLanguage] && settings.translations[this.state.activeLanguage].contact_info || ''}
                                            formActions={this.props.formActions}
                                            helperText={<a href="https://www.markdownguide.org/basic-syntax/"
                                                           target="_blank">{tsl('settings.contact_info.helper')}</a>}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.payment_types')}
                                                      secondary={tsl('settings.payment_types.info')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>
                                        <Select
                                            fullWidth
                                            multiple
                                            value={this.state.settings.payment_type_ids}
                                            onChange={this.handleSelectChange('payment_type_ids')}
                                        >
                                            {this.state.payment_types.map(pt => (
                                                <MenuItem
                                                    key={pt.id}
                                                    value={pt.id}
                                                    style={{
                                                        fontWeight: this.state.settings.payment_type_ids.indexOf(pt.id) !== -1 ? '500' : '400',
                                                    }}
                                                >
                                                    {pt.title}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.exclusive_payment_types')}
                                                      secondary={tsl('settings.exclusive_payment_types.info')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>
                                        <Select
                                            fullWidth
                                            multiple
                                            value={this.state.settings.exclusive_payment_type_ids}
                                            onChange={this.handleSelectChange('exclusive_payment_type_ids')}
                                        >
                                            {this.state.payment_types.map(pt => (
                                                <MenuItem
                                                    key={pt.id}
                                                    value={pt.id}
                                                    style={{
                                                        fontWeight: this.state.settings.exclusive_payment_type_ids.indexOf(pt.id) !== -1 ? '500' : '400',
                                                    }}
                                                >
                                                    {pt.title}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.stripePublicKey')}
                                                      secondary={tsl('settings.stripePublicKey.info')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>
                                        <TextField
                                            validateOnMount
                                            fullWidth
                                            type="text"
                                            name="stripe_public_key"
                                            onChange={this.handleInputChange}
                                            value={settings.stripe_public_key || ''}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.stripe')}
                                                      secondary={tsl('settings.stripe.info')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>

                                        <TextField
                                            validateOnMount
                                            fullWidth
                                            type="password"
                                            name="stripe_secret_key"
                                            onChange={this.handleInputChange}
                                            value={settings.phone || ''}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.currency')}
                                              secondary={tsl('settings.currency.info')}
                                />
                                <ListItemSecondaryAction>
                                    <Select
                                        fullWidth
                                        value={this.state.settings.currency_code}
                                        onChange={this.handleSelectChange('currency_code')}
                                    >
                                        {this.state.currencies.map(c => (
                                            <MenuItem
                                                key={c.code}
                                                value={c.code}
                                                style={{
                                                    fontWeight: this.state.settings.currency_code == c.code ? '500' : '400',
                                                }}
                                            >
                                                {c.code} ({c.symbol})
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.weight_unit')}
                                />
                                <ListItemSecondaryAction>
                                    <Select
                                        fullWidth
                                        value={this.state.settings.weight_unit}
                                        onChange={this.handleSelectChange('weight_unit')}
                                    >
                                        <MenuItem value="kg">
                                            {tsl('settings.unit.kg')}
                                        </MenuItem>

                                        <MenuItem value="lb">
                                            {tsl('settings.unit.lb')}
                                        </MenuItem>
                                    </Select>
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.ampm')}
                                />
                                <ListItemSecondaryAction>
                                    <Switch
                                        checked={settings.ampm}
                                        onChange={this.handleSwitchChange('ampm')}
                                        aria-label="ampm"
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.timezone')}
                                />
                                <ListItemSecondaryAction>
                                    <Select
                                        fullWidth
                                        value={settings.timezone}
                                        onChange={this.handleSelectChange('timezone')}

                                    >
                                        {this.state.timezones.map(tz => (
                                            <MenuItem key={tz} value={tz}>{tz}</MenuItem>
                                        ))}
                                    </Select>
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.voucher_valid_years')}
                                              secondary={tsl('settings.voucher_valid_years.info')}
                                />
                                <ListItemSecondaryAction>
                                    <Select
                                        fullWidth
                                        value={this.state.settings.voucher_valid_years}
                                        onChange={this.handleSelectChange('voucher_valid_years')}
                                    >
                                        {this.years.map(c => (
                                            <MenuItem
                                                key={c}
                                                value={c}
                                                style={{
                                                    fontWeight: this.state.settings.voucher_valid_years == c ? '500' : '400',
                                                }}
                                            >
                                                {tsl('settings.voucher_valid_years.years', {years: c})}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.voucher_bound_to_offer')}
                                              secondary={tsl('settings.voucher_bound_to_offer.info')}
                                />
                                <ListItemSecondaryAction>
                                    <Switch
                                        checked={settings.voucher_bound_to_offer}
                                        onChange={this.handleSwitchChange('voucher_bound_to_offer')}
                                        aria-label="voucher_bound_to_offer"
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.voucher_template')}
                                              secondary={
                                                  <span>
                                          {tsl('settings.voucher_template.info')}

                                                      <IconButton href={this.getTestVoucherLink('html')}
                                                                  target="_blank">
                                            <PreviewIcon/>
                                          </IconButton>
                                          <IconButton href={this.getTestVoucherLink('pdf')} target="_blank">
                                            <DownloadIcon/>
                                          </IconButton>
                                        </span>
                                              }
                                />
                                <ListItemSecondaryAction>
                                    <LogoUpload
                                        file={this.state.settings.voucher_template}
                                        onUpload={this.handleVoucherTemplateUpload}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.logo')}
                                              secondary={tsl('settings.logo.info')}
                                />
                                <ListItemSecondaryAction>
                                    <LogoUpload
                                        file={this.state.settings.logo}
                                        onUpload={this.handleLogoUpload}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.tos')}
                                              secondary={tsl('settings.tos.info')}
                                />
                                <ListItemSecondaryAction>
                                    {tsl('settings.switch.file')} <Switch
                                    checked={settings.tos_is_url}
                                    onChange={this.handleSwitchChange('tos_is_url')}
                                    aria-label="tos_is_url"
                                /> {tsl('settings.switch.url')}
                                </ListItemSecondaryAction>
                            </ListItem>

                            <ListItem>

                                {settings.tos_is_url ?
                                    <TextField
                                        validateOnMount
                                        required
                                        fullWidth
                                        name="tos_url"
                                        onChange={this.handleInputChange}
                                        value={settings.tos_url || ''}
                                        label={tsl('settings.tos.url')}
                                        placeholder="http://"
                                        validations={[
                                            isURL
                                        ]}
                                        formActions={this.props.formActions}
                                    /> :
                                    <div>
                                        <input
                                            type="file"
                                            name="tos_file"
                                            onChange={this.handleUpload}
                                        />
                                    </div>
                                }

                                {
                                    !settings.tos_is_url && settings.tos_file &&
                                    <ListItemText
                                        primary={tsl('settings.file.current')}
                                        secondary={<a target="_blank"
                                                      href={settings.tos_file.url}>{settings.tos_file.title}</a>}
                                    />
                                }
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.safety')}
                                              secondary={tsl('settings.safety.info')}
                                />
                                <ListItemSecondaryAction>
                                    {tsl('settings.switch.file')} <Switch
                                    checked={settings.safety_is_url}
                                    onChange={this.handleSwitchChange('safety_is_url')}
                                    aria-label="safety_is_url"
                                /> {tsl('settings.switch.url')}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                {settings.safety_is_url ?
                                    <TextField
                                        validateOnMount
                                        required
                                        fullWidth
                                        name="safety_url"
                                        onChange={this.handleInputChange}
                                        value={settings.safety_url || ''}
                                        label={tsl('settings.safety.url')}
                                        placeholder="http://"
                                        validations={[
                                            isURL
                                        ]}
                                        formActions={this.props.formActions}
                                    /> :
                                    <input
                                        type="file"
                                        name="safety_file"
                                        onChange={this.handleUpload}
                                    />
                                }

                                {
                                    !settings.safety_is_url && settings.safety_file &&
                                    <ListItemText
                                        primary={tsl('settings.file.current')}
                                        secondary={<a target="_blank"
                                                      href={settings.safety_file.url}>{settings.safety_file.title}</a>}
                                    />
                                }
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.enable_flight_requests')}
                                              secondary={tsl('settings.enable_flight_requests.info')}
                                />
                                <ListItemSecondaryAction>
                                    <Switch
                                        checked={settings.enable_flight_requests}
                                        onChange={this.handleSwitchChange('enable_flight_requests')}
                                        aria-label="enable_flight_requests"
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider light/>

                            <ListItem>
                                <ListItemText className="br-break"
                                              primary={tsl('settings.email_types')}
                                              secondary={tsl('settings.email_types.info')}
                                />

                                <ListItemSecondaryAction>

                                </ListItemSecondaryAction>
                            </ListItem>

                            {this.state.email_types.filter(et => et.context == 'customer').map(et => (
                                <ListItem key={et.name}>
                                    <ListItemText className="br-break"
                                                  primary={et.title}
                                    />

                                    <ListItemSecondaryAction>
                                        <Switch
                                            checked={!settings.email_type_overrides.find(o => o.email_type_id == et.id) ? et.enabled : settings.email_type_overrides.find(o => o.email_type_id == et.id).enabled}
                                            onChange={this.handleEmailSwitchChange(et.id)}
                                            aria-label="email_type_overrides"
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}

                            <Divider light/>

                            <ListItem>
                                <Grid container spacing={24}>

                                    <Grid item sm={6} xs={12}>
                                        <ListItemText className="br-break"
                                                      primary={tsl('settings.survey_url')}
                                                      secondary={tsl('settings.survey_url.info')}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12}>

                                        <TextField
                                            validateOnMount
                                            fullWidth
                                            name="survey_url"
                                            onChange={this.handleInputChange}
                                            value={settings.survey_url || ''}
                                            placeholder="https://"
                                            validations={[
                                                isURL
                                            ]}
                                            formActions={this.props.formActions}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>

                            {/*
                        <Divider light />

                        <ListItem>
                            <Grid container spacing={24}>

                                <Grid item sm={6} xs={12}>
                                    <ListItemText className="br-break"
                                        primary={tsl('settings.language')}
                                        secondary={tsl('settings.language.info')}
                                    />
                                </Grid>

                                <Grid item sm={6} xs={12}>
                                    <Select
                                        fullWidth
                                        value={this.state.language || 0}
                                        onChange={this.handleLanguageChange}
                                    >
                                        {this.state.languages.map((lng, index) => (
                                            <MenuItem
                                                key={index}
                                                value={lng.iso_code}
                                                style={{
                                                    fontWeight: (this.state.language === lng.iso_code) ? '500' : '400',
                                                }}
                                            >
                                                {lng.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </Grid>
                        </ListItem>
                        */}

                        </List>

                    </div>
                </div>
            </Paper>
        );
    }
}

export default connect(() => ({}), {addAlert})(withValidatedInputs(Company));


// WEBPACK FOOTER //
// ./app/used/settings/routes/Company.js